import { kebabCase, map } from 'lodash/fp';

import { CommonQuestions } from '../../types/__codegen__/sanity/graphql';
import { FaqItem } from '../../types/question';

const getFormattedQuestionForAccordion = (questions: CommonQuestions['questions']): FaqItem[] =>
  map(
    (item) => ({
      analyticsLabel: item?.question && kebabCase(item?.question),
      body: item?.answerRaw,
      title: item?.question,
    }),
    questions,
  ) as FaqItem[];
export default getFormattedQuestionForAccordion;
